import { getCurrentAppSlug } from "@/utils/auth";
import { Api, type ApiConfig } from "./api";
import { createFetch } from "./utils/fetch";

type SecurityData = { accessToken?: string };

const sharedOptions: ApiConfig<SecurityData> = {
  baseApiParams: {
    headers: {
      "x-app-slug": getCurrentAppSlug(),
    },
  },
  securityWorker: (securityData) => ({
    headers: {
      ...(!!securityData?.accessToken && {
        Authorization: `Bearer ${securityData.accessToken}`,
      }),
    },
  }),
  customFetch: createFetch(),
};

export const api = new Api<SecurityData>({
  baseUrl: import.meta.env.VITE_BACKEND_URL,
  ...sharedOptions,
});
